export const enhancer = (element) => {
  // Get random option
  const options = ["1", "2", "3", "4", "5", "6", "7", "8"];
  const random = options[Math.floor(Math.random() * options.length)];

  element.setAttribute("data-random-static-shape", random);
};
